module.exports = __webpack_public_path__ + "img/block02.befa842c.webp";